exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".global-notices {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  z-index: 999; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/notices/notices.component.scss
// module id = ../../../../../src/app/shared/components/notices/notices.component.scss
// module chunks = main